import { Loader, Select } from "@mantine/core";
import { useCallback } from "react";

import { useTenantOptions } from "../../api/hooks/tenant/useTenantOptions.ts";
import { AppRoute } from "../../constants.ts";
import { useTenantId } from "../../hooks/useTenantId.ts";
import { useCurrentUserContext } from "../../providers/CurrentUserProvider.tsx";
import { getTenantOptions } from "../../types/tenant.ts";

export const TenantSelect = () => {
  const { user } = useCurrentUserContext();

  const [{ data, fetching }, refresh] = useTenantOptions({ pause: !user });
  const tenants = data?.tenants.data;

  const { tenantId, setTenantId } = useTenantId();

  const handleChange = useCallback(
    (value: string) => {
      setTenantId(value);
      window.location.href = AppRoute.Home;
    },
    [setTenantId]
  );

  if (!user) {
    return;
  }

  return (
    <Select
      size="s"
      styles={{ input: { paddingLeft: "20px" } }}
      icon={fetching ? <Loader size={15} /> : undefined}
      iconWidth={20}
      placeholder="Select Tenant"
      defaultValue={tenantId}
      data={getTenantOptions(tenants)}
      onChange={handleChange}
      onDropdownOpen={refresh}
    />
  );
};
